<template>
  <div style="">
    <preview ref="preview"></preview>
    <div v-bind:style="{height:tableHeight+'px'}" class="sharelist">

      <share-card v-for="(item,index) in shareList" :key="item.id" :shareitem="item">

      </share-card>

    </div>
  </div>
</template>
<script>
  import {
    Button,
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Breadcrumb,
    BreadcrumbItem,

  } from 'element-ui'
  import FileIcon from "@/components/FileIcon.vue"
  import {
    FadeTransition,
    CollapseTransition
  } from 'vue2-transitions';
  import Disk from '@/api/disk.js';
  import Preview from '@/components/Preview.vue'
  import ShareCard from '@/components/ShareCard.vue'
  import Bus from '@/components/Bus/bus.js'

  export default {
    components: {
      Button,
      [Breadcrumb.name]: Breadcrumb,
      [BreadcrumbItem.name]: BreadcrumbItem,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      FileIcon,
      Preview,
      ShareCard,

      FadeTransition,
    },
    data() {
      return {
        tableHeight: document.documentElement.clientHeight - 67,
        files: [

        ],
        selectedRows: [],
        //右键菜单状态
        contextmenuStatus: false,
        //弹出菜单正在操作的对象
        menuItem: null,
        //批量操作按钮显隐
        multiOperatingShow: false,

        //分享列表
        shareList: [],
      };
    },
    mounted() {
      window.onresize = () => {
        this.tableHeight = document.documentElement.clientHeight - 67;
      };
      this.getShareList();
      Bus.$on('refreshShareList', (e) => {
        this.getShareList();
      })
    },
    methods: {


      getShareList() {

        this.$store.commit("showLoading");
        Disk.getShareList().then(res => {
          console.log(res.data);
          this.shareList = res.data;
        }).catch(err => {
          console.error('获取云盘文件失败', err)
        }).finally(() => {
          this.$store.commit("hideLoading");
        })
      },

      preview(name, file_id) {
        if (file_id != "") {
          this.$refs.preview.preview(name, "", file_id);
        } else {
          if (this.menuItem.hasOwnProperty("is_team_dir")) {
            this.openFolder(this.menuItem.id, this.menuItem.name);
          } else {
            this.$refs.preview.preview(this.menuItem.name, "", this.menuItem.id);
          }
        }

      },

    }
  }
</script>
<style>
  div.el-table .el-table__row:hover {
    background-color: #edfaff;
  }

  .el-breadcrumb__inner {
    font-size: 10px;
  }

  .el-breadcrumb {
    width: 100%;
    display: flex;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: scroll;
  }

  .sharelist {
    overflow-y: scroll;
    overflow-x: hidden;
  }
</style>
